export default () => {
  const container = document.querySelector('.js-car-video')

  if (!container) return

  const video = container.querySelector('.js-car-video-video')

  if (!video) return

  // 2. This code loads the IFrame Player API code asynchronously.
  const tag = document.createElement('script')

  tag.src = 'https://www.youtube.com/iframe_api'
  const firstScriptTag = document.getElementsByTagName('script')[0]
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
  console.log(tag)
  const youtube = container.querySelector('.js-car-video-youtube')
  const playbutton = container.querySelector('.js-car-video-button')

  let player = {}
  window.onYouTubeIframeAPIReady = function() {
    console.log('YouTube ready!')
    player = new YT.Player('car-video', {
      height: 'auto',
      width: '100%',
      videoId: youtube.dataset.key,
      playerVars: {
        playsinline: 1
      }
    })
  }

  playbutton.addEventListener('click', e => {
    playbutton.remove()
    video.remove()
    player.playVideo()
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/CarVideo.js